import { Injectable, signal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { PagePermissionMap } from 'src/constants/permissions';
import { AuthenticationData } from 'src/shared/models/authentication-data';
import { Page } from './tabs/tabs-meta';
import * as fp from 'lodash/fp';

@Injectable({ providedIn: 'root' })
export class PermissionService {
  private readonly _permissions = signal<Array<string>>([]);
  public readonly permissions = this._permissions.asReadonly();
  public readonly permissions$ = toObservable(this._permissions);

  constructor() {}

  async init(data: Array<string> | AuthenticationData) {
    let permissions = data instanceof AuthenticationData ? fp.get('jwt.Module', data) : data;
    permissions = permissions || [];
    permissions = Array.isArray(permissions) ? permissions : [permissions];
    this._permissions.set(permissions);
  }

  purge() {
    this._permissions.set([]);
  }

  hasPermission(permission: string) {
    return this._permissions() && this._permissions().some((p) => p === permission);
  }

  isAccessiblePage(page: Page): boolean {
    const pagePermissionCheck = PagePermissionMap[page];
    if (pagePermissionCheck) return pagePermissionCheck(this._permissions()) ?? false;

    return false;
  }
}
